<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h3 class="card-title d-flex">
          List of Contest
          <a href="" target="_blank" class="ml-2">
            <vs-icon icon="info" size="small" />
          </a>
          <vs-button class="ml-auto" type="filled" icon="add_circle" size="small" @click="addingNewItem">Add New
            Contest</vs-button>
        </h3>
        <p class="card-subtitle">List of Contests for Users.</p>
        <vs-row>
          <vs-col class="d-flex drop-width" vs-lg="2" vs-xs="12">
            <vs-select :color="colorx" label="Language Filter" v-model="search.language">
              <vs-select-item value="" text="All Languages" />
              <vs-select-item :key="index" :value="item.culture" :text="item.culture"
                v-for="(item, index) in languages" />
            </vs-select>
          </vs-col>
          <vs-col vs-lg="4" vs-xs="12">
            <vs-button color="primary" type="filled" class="searchBtn" @click="fetchAllContest()"
              icon="search">Search</vs-button>
            <vs-button color="warning" type="filled" class="searchBtn" icon="cached"
              @click="resetData()">Reset</vs-button>
          </vs-col>
        </vs-row>
        <br />
        <table class="table">
          <tr>
            <th>#</th>
            <td></td>
            <th>Title</th>
            <th>Language</th>
            <!-- <th>Contest Id</th> -->
            <th @click="sortByDate('startDate')" style="cursor: pointer;"> Start Date
              <span v-if="sortByField === 'startDate'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th @click="sortByDate('endDate')" style="cursor: pointer;">End Date
              <span v-if="sortByField === 'endDate'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th @click="sortBy('position')" style="cursor: pointer;">Position
              <span v-if="sortByField === 'position'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th @click="sortBy('status')" style="cursor: pointer;">Status
              <span v-if="sortByField === 'status'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th> <!-- <th>Rule</th> -->
            <th>Number Of Winner</th>
            <th></th>
          </tr>
          <tr v-for="(item, index) in all" :key="item.name">
            <td class="td">{{ index + 1 }}</td>
            <td>
              <div class="row">
                <div class="mr-2" v-for="url in item.file" :key="url._id">
                  <img v-if="!url.url" src="../../../assets/images/No-image.png" height="50px" width="75px" />
                  <img v-if="url.url" :src="url.url" height="50px" width="75px" />
                </div>
                <!-- <div class="mr-2" v-if="!all.file">
                  <img
                    src="../../../assets/images/No-image.png"
                    height="50px"
                    width="75px"
                  />
                </div> -->
              </div>
            </td>
            <td class="td">
              {{ item.title }}
            </td>
            <td class="td">
              {{ item.language }}
            </td>
            <!-- <td class="td">
              {{ item.contestId }}
            </td> -->
            <td class="td">{{ item.startDate | formatDate }}</td>
            <td class="td">{{ item.endDate | formatDate }}</td>
            <!-- <td class="td">{{ item.rules }}</td> -->
            <td class="td text-center">{{ item.position }}</td>
            <td class="td">
              <vs-chip v-if="item.active" color="success">Active</vs-chip>
              <vs-chip v-else color="danger">Inactive</vs-chip>
            </td>
            <td class="td text-center">{{ item.numberOfWinners }}</td>
            <td class="td">
              <vs-button class="mr15 mt-2" icon="create" size="small" color="warning"
                @click="editingItem(item, 'edit')">Edit</vs-button>
              <vs-button class="mr15 mt-2" size="small" color="danger" icon="delete_sweep" @click="
                deleteBannerPopup = true;
              itemToDelete = item;
              ">Delete</vs-button>
              <vs-button class="mr15 mt-2" size="small" color="primary" icon="visibility"
                @click="viewAllParticipants(item)">
                Participants
              </vs-button>
              <vs-button class="mr15 mt-2" size="small" color="success" icon="content_copy" @click="copyId(item._id)">
                Copy
              </vs-button>
              <!-- <vs-button
                class="mr15 mb10 mt-1"
                size="small"
                color="primary"
                @click="editingItem(item, 'clone')"
                >Duplicate</vs-button
              > -->
            </td>
          </tr>
        </table>

        <!-- Code -->
        <vs-popup :title="isNew
            ? 'Add New Contest'
            : clone
              ? 'Duplicate Contest'
              : 'Edit Contest'
          " :active.sync="defaultalert">
          <vs-row>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input label="Contest Title* (Keep it Simple and short)" v-model="banner.title" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <label>Contest Description*</label>
              <vs-textarea width="100%" v-model="banner.description" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <label>Contest Rules*</label>
              <vs-textarea width="100%" v-model="banner.rules" />
            </vs-col>
            <!-- <vs-col vs-lg="12" vs-xs="12">
              <vs-input label="Contest Id*" v-model="banner.contestId" />
            </vs-col> -->
            <vs-col vs-lg="12" vs-xs="12" class="mt-2 mb-4">
              <vs-select :color="colorx" label="Contest Language" v-model="banner.language" icon="arrow_downward">
                <vs-select-item value text="Choose Language" disabled />
                <vs-select-item :value="item.culture" :text="item.culture" v-for="(item, index) in languages"
                  :key="index" />
              </vs-select>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input type="number" label="Number of winner" v-model="banner.numberOfWinners" :min="1" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input type="number" label="Contest Position (Try to assign different position)" :min="1"
                v-model="banner.position" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mt-4 p-bottom">
              <vs-checkbox v-model="banner.active">Status (Active / Inactive)</vs-checkbox>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <vs-col class="mt-6" vs-lg="6" vs-xs="6">
                <label>Contest Start Date*</label>
                <br />
                <datepicker placeholder="Start Date" v-model="banner.startDate" id="start_date" format="yyyy-MM-dd"
                  input-class="form-group" :open-date="new Date()" :disabledDates="disabledDates"
                  @selected="dateSelected($event)"></datepicker>
              </vs-col>
              <vs-col class="mt-6" vs-lg="6" vs-xs="6">
                <label>Contest End Date*</label>
                <br />
                <datepicker placeholder="End Date" v-model="banner.endDate" format="yyyy-MM-dd" input-class="form-group"
                  :open-date="new Date()" :disabledDates="disabledDatesEnd"></datepicker>
              </vs-col>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <div>
                <vs-col class="mt-6" vs-lg="6" vs-xs="6">
                  <label>Contest Start Time*</label>
                  <br />
                  <vue-timepicker v-model="banner.startTime" format="hh:mm A"></vue-timepicker>
                </vs-col>
                <vs-col class="mt-6" vs-lg="6" vs-xs="6">
                  <label>Contest End Time*</label>
                  <br />
                  <vue-timepicker v-model="banner.endTime" format="hh:mm A"></vue-timepicker>
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <vs-col class="mt-6" vs-lg="6" vs-xs="6">
                <label>Registration Start Date*</label>
                <br />
                <datepicker placeholder="Registration Start Date" v-model="banner.registrationStartDate" id="start_date"
                  format="yyyy-MM-dd" input-class="form-group" :open-date="new Date()" :disabledDates="disabledDates"
                  @selected="dateSelected($event)"></datepicker>
              </vs-col>
              <vs-col class="mt-6" vs-lg="6" vs-xs="6">
                <label>Registration End Date*</label>
                <br />
                <datepicker placeholder="Voting End Date" v-model="banner.registrationEndDate" format="yyyy-MM-dd"
                  input-class="form-group" :open-date="new Date()" :disabledDates="disabledDatesEnd"></datepicker>
              </vs-col>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <vs-col class="mt-6" vs-lg="6" vs-xs="6">
                <label>Voting Start Date*</label>
                <br />
                <datepicker placeholder="Voting Start Date" v-model="banner.votingStartDate" id="start_date"
                  format="yyyy-MM-dd" input-class="form-group" :open-date="new Date()" :disabledDates="disabledDates"
                  @selected="dateSelected($event)"></datepicker>
              </vs-col>
              <vs-col class="mt-6" vs-lg="6" vs-xs="6">
                <label>Voting End Date*</label>
                <br />
                <datepicker placeholder="Voting End Date" v-model="banner.votingEndDate" format="yyyy-MM-dd"
                  input-class="form-group" :open-date="new Date()" :disabledDates="disabledDatesEnd"></datepicker>
              </vs-col>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <vs-col class="mt-6" vs-lg="6" vs-xs="6">
                <label>Winner Announcing Date*</label>
                <br />
                <datepicker placeholder="Winner Announcing Date" v-model="banner.winnerAnnouncingDate" id="start_date"
                  format="yyyy-MM-dd" input-class="form-group" :open-date="new Date()" :disabledDates="disabledDates"
                  @selected="dateSelected($event)"></datepicker>
              </vs-col>
              <vs-col class="mt-6" vs-lg="6" vs-xs="6">
                <label>Winner Announcing Time*</label>
                <br />
                <vue-timepicker v-model="banner.winnerAnnouncingTime" format="hh:mm A">
                </vue-timepicker>
              </vs-col>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <div>
                <vs-col vs-lg="12" vs-xs="12">
                  <div class="upload-btn-wrapper vs-input-primary">
                    <label class="vs-input--label">Contest Image</label>
                    <div class="btn">
                      <vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload a File
                    </div>
                    <input type="file" ref="fileInput" @change="uploadImage($event)" />
                  </div>
                </vs-col>
                <vs-col v-if="displayImage1.length">
                  <div class="row">
                    <div class="mr-2" v-for="url in displayImage1" :key="url._id">
                      <vs-button color="danger" type="flat" icon="clear" class="closeBtn"
                        @click="deleteImage(url)"></vs-button>
                      <img :src="url.url" class="imgUp" height="100px" width="150px" />
                    </div>
                  </div>
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <label>Winning Prize Details*</label>
              <vs-textarea width="100%" v-model="banner.winningPrizeDetails" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mt-2">
              <vs-button icon="save" @click="btnAddBanner">Save</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>

        <vs-popup class="holamundo" title="Delete Contest" :active.sync="deleteBannerPopup">
          <p>Are you sure you want to delete Contest?</p>
          <div>
            <vs-button icon="delete_forever" class="mr15" @click="deleteBanner">Delete Contest</vs-button>
            <vs-button icon="clear" @click="deleteBannerPopup = false">Cancel</vs-button>
          </div>
        </vs-popup>

        <!-- Code -->
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
// import uploader from "../common/uploader.vue";
import api from "@/rest.js";
import { API } from "@/common/constants";
// import { generateChart } from 'vue-chartjs';
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import Vue from "vue";
// import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).format("DD-MM-YYYY");
  }
});

export default {
  name: "banner",
  components: {
    // uploader,
    Datepicker,
    // DatePicker,
    VueTimepicker,
  },
  data: () => ({
    // time1: [],
    disabledDates: {
      to: new Date(Date.now() - 8640000),
    },
    disabledDatesEnd: {
      to: new Date(Date.now() - 8640000),
    },
    title: "Contest",
    colorx: "#0D2144",
    defaultalert: false,
    viewDetails: false,
    deleteBannerPopup: false,
    isNew: true,
    clone: false,
    sortByField: "",
    sortDirection: "asc",
    search: {
      sort: "ASC",
      language: "",
      status: "1",
      isToday: "false",
    },
    displayImage1: [],
    fileName1: "",
    displayImage2: "",
    fileName2: "",
    displayImage3: "",
    fileName3: "",
    banner: {
      numberOfWinners: "",
      title: "",
      language: "",
      file: [],
      position: "",
      active: false,
      startDate: "",
      startTime: "",
      endTime: "",
      // contestId: "",
      registrationEndDate: "",
      registrationStartDate: "",
      votingEndDate: "",
      votingStartDate: "",
      winnerAnnouncingDate: "",
      winnerAnnouncingTime: "",
      winningPrizeDetails: ""
    },
    itemToDelete: "",
    itemToUpdate: "",
    all: [],
    languages: [],
    detail: {},
  }),
  computed: {
    sortedItems() {
      // eslint-disable-next-line
      return this.all.sort((a, b) => {
        if (this.sortDirection === "asc") {
          return a[this.sortByField] > b[this.sortByField] ? 1 : -1;
        } else {
          return a[this.sortByField] < b[this.sortByField] ? 1 : -1;
        }
      });
    },
  },
  methods: {
    sortBy(field) {
      this.sortByField = field;
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      this.all = this.sortedItems;
    },
    sortByDate(field) {
      this.sortByField = field;
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      this.all = this.sortedItems;
    },
    addingNewItem() {
      this.$data.defaultalert = true;
      this.$data.isNew = true;
      this.$data.banner = {
        numberOfWinners: "",
        title: "",
        language: "",
        image: [],
        startDate: "",
        endDate: "",
        startTime: "",
        endTime: "",
        registrationEndDate: "",
        registrationStartDate: "",
        votingEndDate: "",
        votingStartDate: "",
        winnerAnnouncingDate: "",
        winnerAnnouncingTime: "",
        winningPrizeDetails: "",
      };
      this.$data.displayImage1 = [];
      this.$data.fileName1 = "";
      this.$data.banner.startTime = "";
      this.$data.banner.endTime = "";
      if (document.querySelector(".clear-btn")) {
        document.querySelector(".clear-btn").click();
        setTimeout(() => {
          document.querySelector(".clear-btn").click();
        }, 500);
      }
    },
    editingItem(i, data) {
      this.$data.banner = Object.assign({}, i);
      this.$data.defaultalert = true;
      this.$data.isNew = false;
      this.$data.displayImage1 = i.file;

      this.$data.banner.startTime = i.startTime;
      this.$data.banner.endTime = i.endTime;
      this.$data.clone = data == "clone" ? true : false;
    },
    uploadImage(data) {
      const imageType = ["image/jpeg", "image/jpg", "image/webp"];
      var isValid = false;
      isValid = imageType.indexOf(data.target.files[0].type) > -1

      if (!isValid) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "Only JPEG,JPG,WEBP Image files formats should be supported",
          color: "danger",
          position: "top-right",
        });
        this.$refs.fileInput.value = null;
        return;
      }
      if (data.target.files[0].size > 500000) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "File size should be less than 500kb",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      let formdata = new FormData();
      formdata.append("file", data.target.files[0]);
      formdata.append("banner", this.$data.banner.title);
      this.$vs.loading();
      api
        .post(API.UPLOAD_IMAGE, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.error != null) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Uploading Error",
              text: response.data.error.message,
              color: "danger",
              position: "top-right",
            });
          } else {
            const data = response;
            this.$data.displayImage1.push(data.data.files[0]);
            this.$data.banner.file = this.$data.displayImage1;
            if (response) {
              this.$vs.notify({
                text: "File Uploaded",
                color: "success",
                position: "top-right",
              });
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                text: "File Uploading Failed",
                color: "danger",
                position: "top-right",
              });
            }
            this.$refs.fileInput.value = null;
            this.$emit("input", data);
          }
        })
        .catch(() => { });
      this.$vs.loading.close();
    },
    deleteImage(item) {
      const index = this.$data.displayImage1.indexOf(item);
      if (index > -1) {
        this.$data.displayImage1.splice(index, 1);
      }
    },
    viewAllParticipants(i) {
      this.$router.push("/participants/?id=" + i._id + "&contest=" + i.title);
    },
    dateSelected(e) {
      // console.log(e);
      // this.$data.disabledDatesEnd = e;

      this.$data.disabledDatesEnd = {
        to: e,
      };
      // console.log(new Date(Date.now() - 8640000));
    },
    btnAddBanner() {
      // let apiToCall = API.ADD_CONTEST;
      if (typeof this.$data.banner.startTime == "object") {
        this.$data.banner.startTime =
          this.$data.banner.startTime.hh +
          ":" +
          this.$data.banner.startTime.mm +
          " " +
          this.$data.banner.startTime.A;
      }
      if (typeof this.$data.banner.endTime == "object") {
        this.$data.banner.endTime =
          this.$data.banner.endTime.hh +
          ":" +
          this.$data.banner.endTime.mm +
          " " +
          this.$data.banner.endTime.A;
      }

      let date = new Date(this.$data.banner.startDate);
      let eDate = new Date(this.$data.banner.endDate);

      if (this.$data.banner.startDate) {
        // var dateString = '2019-12-01T10:10:10'.replace(/-/g, '/').replace('T', ' ');

        //         console.log(dateString);
        //         console.log( date.getFullYear() +
        //             "/" +
        //             (date.getMonth() + 1) +
        //             "/" +
        //             date.getDate() +
        //             " " +
        //             this.$data.banner.startTime);

        this.$data.banner.startDate = new Date(
          date.getFullYear() +
          "/" +
          (date.getMonth() + 1) +
          "/" +
          date.getDate() +
          " " +
          this.$data.banner.startTime
        ).toISOString();
      }

      if (this.$data.banner.endDate) {
        this.$data.banner.endDate = new Date(
          eDate.getFullYear() +
          "/" +
          (eDate.getMonth() + 1) +
          "/" +
          eDate.getDate() +
          " " +
          this.$data.banner.endTime
        ).toISOString();
      }
      let data = this.$data.banner;

      this.$data.banner.file = this.$data.displayImage1;

      if (!data.title) {
        this.$vs.notify({
          title: "Contest title required",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (!data.description) {
        this.$vs.notify({
          title: "Contest description required",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (!data.rules) {
        this.$vs.notify({
          title: "Contest rules required",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      // if (!data.contestId) {
      //   this.$vs.notify({
      //     title: "Contest Id required",
      //     color: "danger",
      //     position: "top-right",
      //   });
      //   return;
      // }

      if (!data.startDate) {
        this.$vs.notify({
          title: "Contest start date required",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (!data.endDate) {
        this.$vs.notify({
          title: "Contest end date required",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (!data.startTime) {
        this.$vs.notify({
          title: "Contest start time required",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (!data.endTime) {
        this.$vs.notify({
          title: "Contest end time required",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (!this.$data.displayImage1.length) {
        this.$vs.notify({
          title: "Contest image required",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (!data.registrationStartDate) {
        this.$vs.notify({
          title: "Registration start date",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (!data.registrationEndDate) {
        this.$vs.notify({
          title: "Registration end date required",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (!data.votingStartDate) {
        this.$vs.notify({
          title: "voting start date required",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (!data.votingEndDate) {
        this.$vs.notify({
          title: "voting end date required",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (!data.winnerAnnouncingDate) {
        this.$vs.notify({
          title: "winner announcing date required",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (!data.winnerAnnouncingTime) {
        this.$vs.notify({
          title: "winner announcing time required",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (!data.winningPrizeDetails) {
        this.$vs.notify({
          title: "winning prize details required",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (!this.$data.isNew && !this.$data.clone) {
        this.updateContest();
        return;
      } else if (this.$data.clone) {
        let data = {
          file: this.$data.banner.file,
          startDate: this.$data.banner.startDate,
          endDate: this.$data.banner.endDate,
          startTime: this.$data.banner.startTime,
          endTime: this.$data.banner.endTime,
          title: this.$data.banner.title,
          description: this.$data.banner.description,
          rules: this.$data.banner.rules,
          active: this.$data.banner.active,
          language: this.$data.banner.language,
          position: this.$data.banner.position,
          numberOfWinners: this.$data.banner.numberOfWinners,
          registrationEndDate: this.$data.banner.registrationEndDate,
          registrationStartDate: this.$data.banner.registrationStartDate,
          votingEndDate: this.$data.banner.votingEndDate,
          votingStartDate: this.$data.banner.votingStartDate,
          winnerAnnouncingDate: this.$data.banner.winnerAnnouncingDate,
          winnerAnnouncingTime: this.$data.banner.winnerAnnouncingTime,
          winningPrizeDetails: this.$data.banner.winningPrizeDetails,
        };
        this.createContest(data);
      } else {
        this.createContest(data);
      }
    },
    createContest(data) {
      let apiToCall = API.ADD_CONTEST;
      this.$vs.loading();
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      api
        .post(apiToCall, data, { headers })
        .then((r) => {
          this.$vs.loading.close();
          if (r.data) {
            this.$vs.notify({
              text: "Saved Successfully",
              color: "success",
              position: "top-right",
            });
            this.$data.isNew = true;
            this.$data.itemToUpdate = "";
            this.$data.defaultalert = false;
            (this.$data.banner = {
              numberOfWinners: "",
              title: "",
              language: "",
              file: [],
              startTime: "",
              endTime: "",
              registrationEndDate: "",
              registrationStartDate: "",
              votingEndDate: "",
              votingStartDate: "",
              winnerAnnouncingDate: "",
              winnerAnnouncingTime: "",
              winningPrizeDetails: "",
            }),
              this.fetchAllContest();
          } else {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            text: "ContestId already exist",
            color: "danger",
            position: "top-right",
          });
          this.$vs.loading.close();
          return;
        });
    },
    updateContest() {
      this.$vs.loading();
      let data = this.$data.banner;
      // if (this.$data.banner.startTime.split("T").length != 2) {
      //   this.$data.banner.startTime = new Date(
      //     (
      //       this.$data.banner.startDate.split("T")[0] +
      //       " " +
      //       this.$data.banner.startTime
      //     ).toString()
      //   ).toISOString();
      // }

      // if (this.$data.banner.endTime.split("T").length != 2) {
      //   this.$data.banner.endTime = new Date(
      //     (
      //       this.$data.banner.endDate.split("T")[0] +
      //       " " +
      //       this.$data.banner.endTime
      //     ).toString()
      //   ).toISOString();
      // }
      this.$data.banner.file = this.$data.displayImage1;
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      api
        .put(API.UPDATE_CONTEST + "?id=" + data._id, data, { headers })
        .then((r) => {
          this.$vs.loading.close();
          if (r.data) {
            this.$vs.notify({
              text: "Updated Successfully",
              color: "success",
              position: "top-right",
            });
            this.$data.isNew = true;
            this.$data.itemToUpdate = "";
            this.$data.defaultalert = false;
            (this.$data.banner = {
              numberOfWinners: "",
              title: "",
              language: "",
              file: [],
              startTime: "",
              endTime: "",
              registrationEndDate: "",
              registrationStartDate: "",
              votingEndDate: "",
              votingStartDate: "",
              winnerAnnouncingDate: "",
              winnerAnnouncingTime: "",
              winningPrizeDetails: ""
            }),
              this.fetchAllContest();
          } else {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {
          // this.$vs.notify({
          //   text: "Duplicate ContestId",
          //   color: "danger",
          //   position: "top-right",
          // });
          this.$vs.loading.close();
          return;
        });
    },
    fetchAllContest() {
      if (this.$data.search.language == "all") {
        this.$data.search.language = "EN";
      }
      this.$vs.loading();
      api
        .get(API.GET_CONTEST + "?language=" + this.$data.search.language)
        .then((r) => {
          this.$vs.loading.close();
          this.$data.all = r.data;
          if (!r.data) {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => { });
    },
    deleteBanner() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };
      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      api
        .delete(
          API.DELETE_CONTEST + "?id=" + this.$data.itemToDelete._id,
          {},
          { headers }
        )
        .then((r) => {
          if (r.data) {
            this.$vs.notify({
              text: "Deleted Successfully",
              color: "success",
              position: "top-right",
            });
          } else {
            this.$vs.notify({
              text: "Already Deleted",
              color: "danger",
              position: "top-right",
            });
          }
          this.$data.deleteBannerPopup = false;
          this.fetchAllContest();
        })
        .catch(() => { });
    },
    copyId(guid) {
      var input_temp = document.createElement("input");
      input_temp.value = guid;
      document.body.appendChild(input_temp);
      input_temp.select();
      document.execCommand("copy");
      document.body.removeChild(input_temp);
      this.$vs.notify({
        text: "ID copied",
        color: "success",
        position: "top-right",
      });
    },
    fetchAllLanguages() {
      this.$vs.loading();
      api
        .get(API.GET_LANG, {})
        .then((r) => {
          this.$vs.loading.close();
          this.$data.languages = r.data
        })
        .catch(() => { });
    },
    resetData() {
      this.$data.search = {
        sort: "ASC",
        language: "",
        status: "1",
        isToday: "false",
      };
      this.fetchAllContest();
    },
    viewBannerDetails(i) {
      this.$data.detail.description = i.description;
      this.$data.detail.link = i.link;
      this.$data.viewDetails = true;
    },
  },
  created() {
    this.fetchAllContest();
    this.fetchAllLanguages();
  },
};
</script>
<style scoped>
.mb15 {
  margin-bottom: 15px;
}

.mr15 {
  margin-right: 15px;
}

.td {
  vertical-align: middle;
}

.mt20 {
  margin-top: 20px;
}

.searchBtn {
  margin-top: 25px;
  margin-right: 5px;
  width: 30%;
}

.eye {
  cursor: pointer;
  margin: auto;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 100%;
  cursor: pointer !important;
}

.btn {
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: white;
  padding: 0.4rem;
  border-radius: 0px;
  font-size: 0.85rem;
  width: 100%;
  cursor: pointer;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

td {
  padding: 0.5rem;
}

.p-bottom {
  padding-bottom: 20px;
}

.drop-width {
  width: 150px !important;
}
</style>
